import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';


import { GlobalFlagsService } from '../../../services/global-flags.service';
import { OAuthService } from '../../../services/oauth.service';
import { UserService } from '../../../services/user.service';

import { DialogComponent } from '../../commons/dialog/dialog.component';
import { from } from 'rxjs';
import { passwordErrorsArray } from '../../../commons/config';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private oAuthService: OAuthService,
    private globalFlagsService: GlobalFlagsService,
    private userService: UserService,
    private dialog: MatDialog,
    private location: Location) { }

  isSendingForm: boolean;
  username: string;
  token: any;
  invalidPasswordRules = 0;

  passwordRules = passwordErrorsArray;

  resetForm = {
    password: '',
    confirmPassword: ''
  };

  goBack() {
    this.location.back();
  }

  password: string;
  confirmPassword: string;

  private sub: any;

  ngOnInit() {
    this.oAuthService.logout();
    this.sub = this.route.params.subscribe(params => {
      if (params['token']) {
        this.globalFlagsService.displayLoad(true);
        this.token = params['token'];
        const obj = {
          token: this.token
        };
        const isTokenValid = from(this.userService.getIsValidReset(obj));

        isTokenValid
          .subscribe((res) => {
            this.globalFlagsService.displayLoad(false);
            if (!res.valid) {
              const message = 'The link is no longer valid.';
              this.openDialog({ message });
              this.router.navigate(['/']);
            }
          }, (err) => {
            this.globalFlagsService.displayLoad(false);
            const message = 'The link is no longer valid.';
            this.openDialog({ message });
            this.router.navigate(['/']);
          });
      }
    });
  }

  checkPasswordError(passwordErrors, id) {
    if (!passwordErrors) {
      this.invalidPasswordRules = 0;
      return;
    }
    for (const key in passwordErrors) {
      if (passwordErrors.hasOwnProperty(key)) {
        if (passwordErrors[key].id === id) {
          this.invalidPasswordRules++;
          return 'invalid';
        }
      }
    }
  }

  sendNewPassword() {
    this.globalFlagsService.displayLoad(true);
    this.isSendingForm = true;
    const resetObj = {
      'tokenConfirm': this.token,
      'secMemberships': [
        {
          'password': this.resetForm.password
        }
      ]
    };

    const resetPassword = from(this.userService.resetPasswordReset(resetObj));

    resetPassword
      .subscribe((res) => {
        console.log(res);
        this.globalFlagsService.displayLoad(false);
        this.isSendingForm = false;
        const message = 'Your password has been successfully changed';
        this.openDialog({ message });
        this.router.navigate(['/']);
      }, (err) => {
        console.log(err);
        this.globalFlagsService.displayLoad(false);
        this.isSendingForm = false;
        const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
        const message = `${errMsg}. Please try again.`;
        this.openDialog({ message });
        throw err;
      });
  }

  openDialog(data) {
    this.dialog.open(DialogComponent, { data });
  }

  goToLogin(){
    this.router.navigate(['/login']);
  }

}
